import { node, object } from "prop-types";
import { observer } from "mobx-react";
import { Grid } from "@material-ui/core";
import useCellStyle from "../../../../../../styles/CommonTableCellStyles.style";
import classnames from "classnames";

export const NumerationContainer = observer(({
  element,
  children,
  className="mr-3",
}) => {
  const cellClasses = useCellStyle();
  
  const { displayNumeration } = element;
  
  // const handleNumerationChange = (value) => {
  //   element.setCustomNumeration(value);
  // }

  return (
    <Grid
      item container
      alignItems="center"
      justifyContent="flex-end"
      wrap="nowrap"
      className={classnames(cellClasses.cellInner, "w-max")}
    >
      <span className={className}>
        {displayNumeration}
      </span>
      {children}
    </Grid>
  );
});

NumerationContainer.propTypes = {
  element: object.isRequired,
  children: node,
};
